import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        customPurple: "#6609FF",
        primary: "rgb(102, 9, 255)",
      },
    },
  },
});
